import { HttpClient } from '@angular/common/http';
import { Inject } from '@angular/core';
import { CrudService, ENVIRONMENT, HateoasMultipleResponseObject, PageSpecification, addPageSpecificationParameters, appendSerialisedHttpParams } from '@scisys-uim/uim-common';
import { FIREARM_POOL_TYPE, FirearmPool } from 'assets-model';
import { Observable } from 'rxjs';



export abstract class FirearmPoolServiceBase extends CrudService<FirearmPool, number> {

  servicePath: string = '/firearmpool';

  constructor(protected http: HttpClient, 
      @Inject(ENVIRONMENT) protected environment: any) {
    super(http, environment, FIREARM_POOL_TYPE.entityDecorator);
  }

  public findByFullFilters(filters: any, pageSpec?: PageSpecification, reduced: boolean = true): Observable<HateoasMultipleResponseObject<FirearmPool>> {
    var params = appendSerialisedHttpParams(filters);
	
    params = appendSerialisedHttpParams(reduced, 'reduced', params);

    if (pageSpec) {
      params = addPageSpecificationParameters(pageSpec, params);
    }
	
    return this.deserialiseMultipleResponse(this.http.get<HateoasMultipleResponseObject<FirearmPool>>(this.serviceBaseUrl + (pageSpec ? '/findByFullFilters' : '/findByFullFiltersUnpaged'), {
      params: params
    }));
  }
}



